// extracted by mini-css-extract-plugin
export default {"container":"Header_container__GAf-3","title":"Header_title__n-tx7","text":"Header_text__nOlmb"};